import { render, staticRenderFns } from "./OpenCourseItem.vue?vue&type=template&id=04645d6c&scoped=true&"
import script from "./OpenCourseItem.vue?vue&type=script&lang=js&"
export * from "./OpenCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./OpenCourseItem.vue?vue&type=style&index=0&id=04645d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04645d6c",
  null
  
)

export default component.exports